/**
 * Shared CoreAPI React context.
 *
 * Lives here (not in apps/web) so feature-module route components can read
 * `core` without importing the host app. `@praesto/contracts` stays frozen;
 * this is additive React glue (core already has react as a peerDependency).
 * Server consumers (functions) don't import @praesto/core, so no React is
 * pulled server-side.
 */
import { createContext, createElement, useContext } from "react";
import type { ReactNode } from "react";
import type { CoreAPI } from "@praesto/contracts";

const CoreContext = createContext<CoreAPI | null>(null);

export function CoreProvider({ value, children }: { value: CoreAPI; children: ReactNode }) {
  return createElement(CoreContext.Provider, { value }, children);
}

export function useCore(): CoreAPI {
  const core = useContext(CoreContext);
  if (!core) {
    throw new Error("useCore must be used within a <CoreProvider>");
  }
  return core;
}
